/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Team_Members_LabelInputs */



/**
* | output |
* | --- |
* | "Team Members" |
*
* @param {Team_Share_Team_Members_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_team_members_label = /** @type {((inputs?: Team_Share_Team_Members_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Team_Members_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Membres de l’équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teammitglieder")
	if (locale === "it") return /** @type {LocalizedString} */ ("Membri del team")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Члены команды")
	if (locale === "es") return /** @type {LocalizedString} */ ("Miembros del equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("团队成员")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームメンバー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम के सदस्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Membros da equipe")
	return /** @type {LocalizedString} */ ("Team Members")
});